<template>
    <modal ref="cancelarAdminDirecto" titulo="Cancelar pedido" icon="close" @guardar="cancelar_pedido">
        <ValidationObserver ref="form2">
            <div class="row mx-0 justify-center text-general">
                <div class="col-10 text-center">
                    Es una lástima que quieras cancelar el pedido, cuéntanos por que tomas esta decisión.
                </div>
            </div>
            <div class="row mx-0 my-3 justify-center">
                <div class="col-10">
                    <label class="pl-3 f-12 text-general">Motivo de la cancelación</label>
                    <ValidationProvider v-slot="{ errors }" rules="required" name="motivo">
                        <el-select v-model="model.id_motivo" size="small" class="w-100">
                            <el-option
                            v-for="item in motivos"
                            :key="item.id"
                            :label="item.nombre"
                            :value="item.id"
                            />
                        </el-select>
                        <span class="text-danger f-11">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="row mx-0 my-3 justify-center">
                <div class="col-10 text-general">
                    <label class="pl-3 f-12">Justificación</label>
                    <ValidationProvider v-slot="{ errors }" rules="required" name="justificacion">
                        <el-input v-model="model.justificacion" type="textarea" show-word-limit maxlength="250" :rows="3" />
                        <span class="text-danger f-11">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </ValidationObserver>
    </modal>
</template>

<script>
import PedidosTienda from '~/services/pedidos/pedidos-tienda'
import PedidosAdmin from '~/services/pedidos/pedidos-admin'
import {mapGetters} from 'vuex'
export default {
    data(){
        return {
            model:{
                id_motivo:null,
                justificacion:'',

            },
            motivos:[]
        }
    },
    computed:{
        ...mapGetters({
            id_pedido: 'pedidos/pedidos_admin/id_pedido',
            pedido: 'pedidos/pedidos_admin/pedido'
        }),
    },
    methods:{
        toggle(){
            this.select_motivos()
            this.model = {
                id_motivo:null,
                justificacion:''
            }
            this.$refs.cancelarAdminDirecto.toggle()
        },
        async select_motivos(){
            try {
                let params = {
                    tipo:3
                }
                const {data} = await PedidosTienda.select_motivos(params)
                this.motivos = data.motivos

            } catch (e){
                this.error_catch(e)
            }
        },
        async cancelar_pedido(){
            try {
                const valid = await this.$refs.form2.validate()
                if(valid){
                    if(this.id_pedido === null){
                        this.notificacion('Alerta','Por favor seleccione un pedido','warning')
                        return
                    }

                    this.model.id_pedido = this.id_pedido
                    this.model.estado = 27
                    this.model.directo = true
                    const {data} = await PedidosAdmin.rechazar_cancelar_tendero(this.model)

                    let model2 = {
                        id_pedido: this.pedido.id_pedido,
                        id_motivo: this.model.id_motivo,
                        justificacion: this.model.justificacion,
                        directo:true
                    }
                    await PedidosTienda.cancelar_tendero(this.pedido.id_pedido,model2)

                    this.$emit('accion-cancelar')
                    this.notificacion('Mensaje','Pedido Cancelado','success')
                    this.$refs.cancelarAdminDirecto.toggle()

                }
            } catch (e){
                this.error_catch(e)
            }
        }
    }
}
</script>

<style lang="css" scoped>
</style>
